import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function fmtPHP(n) {
  const v = Number.isFinite(+n) ? +n : 0;
  return new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-PH", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-PH", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export const LOAN_STATUSES = [
  "Pending",
  "Under Review",
  "Approved",
  "Rejected",
  "Disbursed",
  "Active",
  "Fully Paid",
  "Overdue",
];

export const STATUS_STYLES = {
  Pending: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  "Under Review": "bg-blue-500/15 text-blue-300 border-blue-500/40",
  Approved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  Rejected: "bg-rose-500/15 text-rose-300 border-rose-500/40",
  Disbursed: "bg-cyan-500/15 text-cyan-300 border-cyan-500/40",
  Active: "bg-emerald-600/20 text-emerald-200 border-emerald-500/50",
  "Fully Paid": "bg-purple-500/15 text-purple-300 border-purple-500/40",
  Overdue: "bg-red-500/20 text-red-300 border-red-500/60 pulse-overdue",
};

export async function downloadBlob(url, filename, params) {
  const { data } = await api.get(url, { params, responseType: "blob" });
  const href = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}

export async function openBlob(url) {
  const w = window.open("", "_blank");
  const { data } = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(data);
  if (w) w.location.href = href;
  else window.location.href = href;
  setTimeout(() => URL.revokeObjectURL(href), 60000);
}

export const MIN_LOAN = 50000;
export const MAX_LOAN = 3000000;
export const FLAT_RATE = 0.003;
export const TERMS = [6, 12, 24, 36];

export function computeLoan(amount, months) {
  const monthlyInterest = +(amount * FLAT_RATE).toFixed(2);
  const totalInterest = +(monthlyInterest * months).toFixed(2);
  const total = +(amount + totalInterest).toFixed(2);
  const monthly = +(total / months).toFixed(2);
  return {
    principal: amount,
    term_months: months,
    monthly_interest: monthlyInterest,
    monthly_payment: monthly,
    total_interest: totalInterest,
    total_repayment: total,
    interest_rate_monthly: FLAT_RATE,
  };
}
